import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import styles from "./Home.module.css";
import {
  Badge,
  Button,
  Row,
  Col,
  Card,
  message,
  Table,
  Typography,
  Modal,
  Form,
  Divider,
  Input,
  Select,
  Spin,
  Tooltip,
} from "antd";
import { fetchJsData, researchAuth, researchUI } from "../../api";
import { PlusOutlined } from "@ant-design/icons";
import { fieldRules } from "../ResearchUI/HardValues";

const { Text, Link } = Typography;

let USERNAME = null;

const cardProp = {
  size: "small",
  headStyle: {
    fontSize: "14px",
    lineHeight: "8px",
    minHeight: "20px",
  },
};

const fetchAppAssign = async (email) => {
  const data = await fetchJsData({
    type: "fetch",
    qry: "fetUsrAppAssign",
    preProcess: false,
    firstVal: email,
  });
  return data;
};

export const ResearchersSection = ({ role, email }) => {
  USERNAME = email.split("@")[0];

  const defaultCol = [
    {
      title: "App ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      width: "10%",
      render: (text) => <Link href={"/cciresearch/" + text}>{text}</Link>,
    },
    {
      title: "Name",
      dataIndex: "appname",
      key: "appname",
      sorter: (a, b) => (a.appname ? a.appname.localeCompare(b.appname) : 1),
      width: "40%",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category ? a.category.localeCompare(b.category) : 1),
      width: "30%",
    },
    {
      title: "Hidden Count",
      dataIndex: "hidden_count",
      key: "hidden_count",
      sorter: (a, b) => a.hidden_count - b.hidden_count,
      width: "10%",
    },
  ];
  const searchCol = [
    {
      title: "App ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      render: (text) => <Link href={"/cciresearch/" + text}>{text}</Link>,
      width: "5%",
    },
    {
      title: "Name",
      dataIndex: "appname",
      key: "appname",
      sorter: (a, b) => (a.appname ? a.appname.localeCompare(b.appname) : 1),
      textWrap: "word-break",
      width: "15%",
      render: (text, record) => (
        <Tooltip title={"Application Name: " + record.application_name}>
          {text}
        </Tooltip>
      ),
    },
    {
      title: "URL",
      dataIndex: "url",
      key: "url",
      sorter: (a, b) => (a.url ? a.appname.localeCompare(b.url) : 1),
      width: "35%",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category ? a.category.localeCompare(b.category) : 1),
      width: "15%",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => (a.status ? a.status.localeCompare(b.status) : 1),
      width: "20%",
    },
    {
      title: "Assign To",
      dataIndex: "assign",
      key: "assign",
      width: "10%",
    },
  ];

  const [loading, setLoading] = useState(false);
  const [assignAppData, setAssignAppData] = useState([]);
  const [addModalVis, setAddModalVis] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableCol, setTableCol] = useState(defaultCol);
  const [searchLoading, setSearchLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const { data: users } = await fetchAppAssign(email);
      setAssignAppData(users);
      setTableData(users);
      if (users) setLoading(false);
    };
    fetchData();
  }, []);

  function onClickTokenFetch(appid) {
    const fetchData = async () => {
      const fetchSearchData = await researchAuth({
        username: email,
      });
      console.log("Token Generated");
      const url =
        "https://cciresearch.netskope.io/appIndex/welcome/editAppDataTest?id=" +
        appid +
        "&email=" +
        email +
        "&token=" +
        fetchSearchData;
      if (fetchSearchData == 0) {
        console.log("Error in token generation");
        message.error("Something Went Wrong. Error : Token Generate Error.");
      } else {
        const newWindow = window.open(url, "_blank", "noopener");
      }
    };
    fetchData();
  }

  const onAppModalClose = () => {
    setAddModalVis(false);
  };

  const onAppSearch = (searchVal) => {
    const searchData = async () => {
      setSearchLoading(true);
      const result = await fetchJsData({
        type: "fetch",
        qry: "fetSearchApp",
        preProcess: false,
        firstVal: "%" + searchVal + "%",
        secondVal: "%" + searchVal + "%",
        thirdVal: "%" + searchVal + "%",
        fourthVal: "%" + searchVal + "%",
      });
      setTableData(result["data"]);
      setTableCol(searchCol);
      setSearchLoading(false);
    };
    if (searchVal.length > 3) {
      searchData();
    }
  };

  const onAppSearchChange = (e) => {
    if (e.target == null || e.target.value.length == 0) {
      console.log(e);
      setTableData([]);
      setTableCol(defaultCol);
      setTimeout(function () {
        setTableData(assignAppData);
      }, 500);
      console.log(tableData);
    }
  };

  const onAppSearchId = (searchVal) => {
    const searchData = () => {
      setSearchLoading(true);
      const result = fetchJsData({
        type: "fetch",
        qry: "fetSearchAppById",
        preProcess: false,
        firstVal: searchVal,
      }).then((result) => {
        setTableData(result["data"]);
        setTableCol(searchCol);
        setSearchLoading(false);
      });
    };
    searchData();
  };

  return (
      <div className="ns-margin-left-large ns-margin-right-large">
          <div className="ns-margin-top-small ns-margin-bottom-small">
              <Button type={'primary'} href="/marketplace">
                  Market Place
              </Button>
          </div>

          <Card
              title="Apps Assigned To Me"
              size="small"
              headStyle={{ backgroundColor: '#F0F8FF', border: 0 }}
              extra={
                  <Row gutter={16} align={'middle'}>
                      <Col>
                          <Input.Search
                              size={'small'}
                              placeholder="Search ID"
                              style={{ width: '150px' }}
                              onSearch={onAppSearchId}
                              onChange={onAppSearchChange}
                              loading={searchLoading}
                          ></Input.Search>
                      </Col>
                      <Col>
                          <Input.Search
                              size={'small'}
                              placeholder="Search Name, URL, Status"
                              style={{ width: '300px' }}
                              onChange={onAppSearchChange}
                              onSearch={onAppSearch}
                              loading={searchLoading}
                          ></Input.Search>
                      </Col>
                      <Col>
                          <Tooltip title={'Add App'}>
                              <PlusOutlined style={{ cursor: 'pointer' }} onClick={() => setAddModalVis(true)} />
                          </Tooltip>
                      </Col>
                  </Row>
              }
          >
              <Table
                  rowKey="id"
                  size="small"
                  bordered
                  scroll={{ x: 400, y: 900 }}
                  style={{ margin: '2px' }}
                  dataSource={tableData}
                  className={styles.ant_table}
                  columns={tableCol}
                  loading={loading}
                  tableLayout={'fixed'}
                  pagination={{
                      pageSizeOptions: ['10', '30', '60', '100', '1000'],
                      defaultPageSize: '50',
                      showSizeChanger: true,
                  }}
              />
          </Card>
          <Modal title="App Addition Request" visible={addModalVis} onCancel={onAppModalClose} width={'80%'} destroyOnClose>
              <AddAppModal setModalVis={onAppModalClose} />
          </Modal>
      </div>
  );
};

const AddAppModal = (props) => {
  const tableColumns = [
    {
      title: "App Name",
      dataIndex: "req_appName",
      width: "15%",
      render: (text, record) => (
        <Tooltip title={new Date(record.createdAt).toUTCString()}>
          {text}
        </Tooltip>
      ),
    },
    { title: "URL", dataIndex: "req_url", width: "30%" },
    { title: "Category", dataIndex: "req_category", width: "30%" },
    { title: "Status", dataIndex: "status", width: "10%" },
  ];

  const [loading, setLoading] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [appExistTableData, setAppExistTableData] = useState([]);
  const [addForm] = Form.useForm();

  useEffect(() => {
    const fetchInitData = async () => {
      setLoading(true);
      const result = await researchUI({
        function: "getAllInitData",
      });
      if (result.success == 1) {
        setCategoryList(
          result.data.category.map((cat) => {
            return { label: cat.category_name, value: cat.category_name };
          })
        );
        await fetchPendingReq();
      } else {
        message.error("Something Went Wrong");
      }
    };

    const fetchPendingReq = async () => {
      const result = await researchUI({
        function: "appChanges",
        reqType: "GetReqsByUser",
        requestedBy: USERNAME,
      });
      setTableData(result.data.pending);
      setLoading(false);
    };

    fetchInitData();
  }, []);

  const catSelProp = {
    showSearch: true,
    options: categoryList,
    optionFilterProp: "label",
    filterOption: (input, option) =>
      option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0,
    filterSort: (optionA, optionB) =>
      optionA.label.toLowerCase().localeCompare(optionB.label.toLowerCase()),
    style: { width: "300px" },
    size: "small",
  };

  const onAddFormFinish = (values) => {
    const addAppReq = async () => {
      const result = await researchUI({
          function: 'appChanges',
          req_type: 'ADD',
          req_appName: values.add_appName.trim(),
          req_url: values.add_URL,
          req_category: values.add_Category,
          comments: values.add_comments,
          requestedBy: USERNAME,
          status: 'Pending',
          reqType: 'New',
      })
          .then((result) => {
              if (result.success == 1) {
                  console.log(result);
                  message.success('App Addition Request Submitted');
                  setAppExistTableData([]);
                  props.setModalVis();
              } else {
                  setAppExistTableData(result.data.tableData);
                  message.error(result.data.msg);
              }
          })
          .catch(() => message.error('Something Went Wrong.'));
    };
    addAppReq();
  };
  return (
    <>
      {loading ? (
        <Row justify="center" gutter={24}>
          <Col span={1}>
            <Spin tip="Loading..."></Spin>
          </Col>
        </Row>
      ) : (
        <>
          <Row gutter={[0, 16]}>
            {appExistTableData.length > 0 ? (
              <Col span={24}>
                <Badge.Ribbon text="Exist" color="red">
                  <Card title="Already Exist Apps" size="small">
                    <Table
                      bordered
                      dataSource={appExistTableData}
                      columns={[
                        {
                          title: "App ID",
                          dataIndex: "application_id",
                          render: (text) => (
                            <a target={"_blank"} href={"/cciresearch/" + text}>
                              {text}
                            </a>
                          ),
                        },
                        {
                          title: "Ref Table",
                          dataIndex: "table",
                        },
                        {
                          title: "Data",
                          dataIndex: "data",
                        },
                      ]}
                      pagination={false}
                    ></Table>
                  </Card>
                </Badge.Ribbon>
              </Col>
            ) : (
              ""
            )}
            <Col span={24}>
              <Card title={"New App Addition Request"} {...cardProp}>
                <Form
                  form={addForm}
                  preserve={false}
                  onFinish={onAddFormFinish}
                  size={"small"}
                >
                  <Row gutter={2}>
                    <Col span={8}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        App Name
                      </Divider>
                      <Form.Item name="add_appName" rules={fieldRules.appName}>
                        <Input size={"small"} placeholder={"App Name"} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        URL
                      </Divider>
                      <Form.Item name="add_URL" rules={fieldRules.url}>
                        <Input size={"small"} placeholder={"URL"} />
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        Category
                      </Divider>
                      <Form.Item
                        name="add_Category"
                        rules={fieldRules.category}
                      >
                        <Select {...catSelProp}></Select>
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <Divider
                        orientation={"left"}
                        className={styles.dividerSmall}
                      >
                        Comment
                      </Divider>
                      <Form.Item name="add_comments">
                        <Input.TextArea
                          placeholder={"Comments"}
                        ></Input.TextArea>
                      </Form.Item>
                    </Col>
                  </Row>
                  <Form.Item>
                    <Button htmlType="submit">Submit</Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
            <Col span={24}>
              <Table
                bordered
                dataSource={tableData}
                columns={tableColumns}
                pagination={false}
                size={"small"}
              />
            </Col>
          </Row>
        </>
      )}
    </>
  );
};
